import { all } from "redux-saga/effects";
import { showReceiptSaga } from "../views/Authenticated/Receipt/store/saga";

const rootSaga = function* rootSaga() {
  yield all([showReceiptSaga()]);
};

export default rootSaga;
